import FeatureFlagDialog from './FeatureFlagDialog.vue';
import { type ModalV2Props, useModalStore } from '../ModalV2/modal-store';
import type { Component } from 'vue';
import { $t } from '@teachino/shared-i18n';

export type FeatureFlagDialogProps = {} & ModalV2Props<undefined>;

export const openFeatureFlagDialog = () => {
  return useModalStore().openModal<FeatureFlagDialogProps, undefined>({
    title: $t('feature_flags.title'),
    size: 'md',
    component: FeatureFlagDialog as Component,
    props: {},
  });
};
